(function () {
  'use strict';

  function init(root) {
    var dialog = root.querySelector('[data-preview-nav]');
    var openButtons = root.querySelectorAll('[data-preview-menu]');
    var closeButtons = root.querySelectorAll('[data-preview-menu-close]');
    if (!dialog || dialog.dataset.previewReady === 'true') return;
    dialog.dataset.previewReady = 'true';
    openButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        dialog.showModal();
        openButtons.forEach(function (item) { item.setAttribute('aria-expanded', 'true'); });
      });
    });
    closeButtons.forEach(function (button) {
      button.addEventListener('click', function () { dialog.close(); });
    });
    dialog.addEventListener('cancel', function (event) {
      event.preventDefault();
      dialog.close();
    });
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) dialog.close();
    });
    dialog.addEventListener('close', function () {
      openButtons.forEach(function (item) { item.setAttribute('aria-expanded', 'false'); });
    });
  }

  document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
}());
